import React from 'react';
import { useRouter } from 'next/router';
import { CountLabel } from '@dealroadshow/uikit/core/components/Badge/CountLabel';
import { useInventoryTableContext } from '@/finsight/application/Bonds/InventoryTableContext';
import { useBwicTableContext } from '@/finsight/application/Bonds/BwicTableContext';
import { LABEL_COLOR_COUNT } from '@/finsight/ui/components/bonds/constants';

const BwicCountLabelContainer = (props) => {
  const {
    isInventoriesFetching,
    inventoriesData: { inventories: { totalCount: inventoriesTotalCount } },
  } = useInventoryTableContext();

  const {
    query: {
      q,
      hash,
    },
  } = useRouter();
  const {
    isBwicFetching,
  } = useBwicTableContext();

  const canShowCount = (!isInventoriesFetching && !isBwicFetching) && (q || hash);
  return (
    <CountLabel
      { ...props }
      canShowCount={ canShowCount }
      backgroundColor={ LABEL_COLOR_COUNT }
      maxTotalCount={ 99 }
      totalCount={ inventoriesTotalCount }
    />
  );
};

export default BwicCountLabelContainer;
